<div class="terrain-height" [ngClass]="this.terrainHeightService.active? 'active' : ''">
  <div class="terrain-height_container">
  </div>
</div>
